export default __webpack_public_path__ + "static/media/bg-coupon-disable.33fa4a52.png";